import { render, staticRenderFns } from "./ThirdPartyBenefits.vue?vue&type=template&id=49e82b06"
import script from "./ThirdPartyBenefits.vue?vue&type=script&lang=js"
export * from "./ThirdPartyBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports